(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[941],{

/***/ 9888:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/order",
      function () {
        return __webpack_require__(5319);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1635:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_error__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2918);
/* harmony import */ var _lib_context__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2523);
/* harmony import */ var _components_layout__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5358);
/* harmony import */ var _components_modules__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1939);






var NotFoundPage = function(param) {
    var data = param.data;
    var ref;
    var site = data.site, menus = data.menus, page = data.page;
    var updateSiteTheme = (0,_lib_context__WEBPACK_IMPORTED_MODULE_3__/* .useUpdateSiteTheme */ .nc)();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        updateSiteTheme(false);
    }, []);
    if (!page) {
        return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_error__WEBPACK_IMPORTED_MODULE_2__["default"], {
            title: "\"Error Page (404)\" is not set in Sanity, or the page data is missing",
            statusCode: "Data Error"
        }));
    }
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_layout__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        site: site,
        page: page,
        children: (ref = page.modules) === null || ref === void 0 ? void 0 : ref.map(function(module, key) {
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_modules__WEBPACK_IMPORTED_MODULE_5__/* .Module */ .Y, {
                index: key,
                module: module
            }, key);
        })
    }));
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (NotFoundPage);


/***/ }),

/***/ 5319:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_error__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2918);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1163);
/* harmony import */ var _lib_context__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2523);
/* harmony import */ var _pages_404__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1635);
/* harmony import */ var _components_layout__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5358);
/* harmony import */ var _components_modules__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1939);









var ContactPage = function(param) {
    var data = param.data;
    var ref;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    var updateSiteTheme = (0,_lib_context__WEBPACK_IMPORTED_MODULE_5__/* .useUpdateSiteTheme */ .nc)();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        updateSiteTheme(false);
    }, []);
    if (!router.isFallback && !data) {
        return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pages_404__WEBPACK_IMPORTED_MODULE_6__["default"], {
            statusCode: 404
        }));
    }
    var site = data.site, page = data.page;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_layout__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        site: site,
        page: page,
        children: (ref = page.modules) === null || ref === void 0 ? void 0 : ref.map(function(module, key) {
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_modules__WEBPACK_IMPORTED_MODULE_8__/* .Module */ .Y, {
                index: key,
                module: module
            }, key);
        })
    }));
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (ContactPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [922,483,774,888,179], function() { return __webpack_exec__(9888); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);